import React, { useState, useEffect } from 'react';

import { Downloader } from '@rs-ui/views/utils/downloader';

// mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// icons
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const FeatureBarGeneric = ({ onDownloadTrayClick, downloadTrayIsOpen }) => {
	const [showDownloader, setShowDownloader] = useState(false);

	useEffect(() => {
		const downloader = new Downloader();

		function handler(sender, args) {
			if (sender === downloader && args.name === 'downloadQueueChanged') {
				if (args.newValue?.length > 0) {
					setShowDownloader(true);
				} else {
					setShowDownloader(false);
				}
			}
		}

		downloader.downloadProcessed.subscribe(handler);
	}, []);

	useEffect(() => {
		if (!showDownloader && downloadTrayIsOpen) {
			onDownloadTrayClick();
		}
	}, [showDownloader]);

	return (
		<Box minWidth="24px" width="auto">
			{showDownloader && (
				<Tooltip placement="left" title="Downloads">
					<IconButton
						centerRipple={false}
						data-testid="DownloadBtn"
						sx={{
							height: '40px',
							borderRadius: '0px',
							color: downloadTrayIsOpen ? 'rsPrimary.button' : 'icon.primary',
						}}
						onClick={onDownloadTrayClick}
					>
						<FileDownloadOutlinedIcon />
					</IconButton>
				</Tooltip>
			)}
		</Box>
	);
};

export default FeatureBarGeneric;
